import { render, staticRenderFns } from "./InactivityModal.vue?vue&type=template&id=23f67ae0&scoped=true"
import script from "./InactivityModal.vue?vue&type=script&lang=js"
export * from "./InactivityModal.vue?vue&type=script&lang=js"
import style0 from "./InactivityModal.vue?vue&type=style&index=0&id=23f67ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f67ae0",
  null
  
)

export default component.exports